// src/lib/notifications.js

const isBrowser = typeof window !== "undefined";

/* ---------------- permission ---------------- */
export async function ensureNotificationPermission() {
  if (!isBrowser || !("Notification" in window)) return "unsupported";

  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";

  try {
    return await Notification.requestPermission();
  } catch {
    return "default";
  }
}

/* ---------------- tags + routes ---------------- */
export const notif = {
  dmKey: (userId) => `dm:${userId}`,
  dmRoute: (userId) => `/messenger?user=${encodeURIComponent(userId || "")}`,

  projectKey: (projectId) => `project:${projectId}`,
  projectRoute: (projectId) =>
    projectId
      ? `/messenger/project-communication?projectId=${encodeURIComponent(
          projectId,
        )}`
      : "/messenger/project-communication",

  announceKey: (company) => `announce:${String(company || "SVB")}`,
  announceRoute: () => "/messenger",
};

/* ---------------- show a notification ---------------- */
export function notifyChat({
  title = "New message",
  body = "",
  tag,
  route,
  icon = "/logo192.png",
} = {}) {
  if (!isBrowser || !("Notification" in window)) return null;
  if (Notification.permission !== "granted") return null;

  try {
    const n = new Notification(title, {
      body,
      tag, // same tag replaces the older notification
      icon,
      renotify: Boolean(tag),
    });

    n.onclick = () => {
      try {
        window.focus();
        if (route) window.location.assign(route);
      } catch {}
      n.close();
    };

    return n;
  } catch (err) {
    console.error("notifyChat error:", err);
    return null;
  }
}